import { render, staticRenderFns } from "./EarlyProductListItem.vue?vue&type=template&id=45910464&scoped=true"
import script from "./EarlyProductListItem.vue?vue&type=script&lang=js"
export * from "./EarlyProductListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../production-parity-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45910464",
  null
  
)

export default component.exports